// extracted by extract-css-chunks-webpack-plugin
module.exports = {"product_arrival_wrapper":"estimatedInstockTime__product_arrival_wrapper","arrival-info":"estimatedInstockTime__arrival-info"};